let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3aRYT"), load("bX9YT"), load("5sjAY"), load("9xeQ7")]).then(() => parcelRequire('5l444'));